// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkflowStage = {
    Draft: 'DRAFT',
    Review: 'REVIEW',
    Approved: 'APPROVED',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type WorkflowStage = typeof WorkflowStage[keyof typeof WorkflowStage];


export function instanceOfWorkflowStage(value: any): boolean {
    for (const key in WorkflowStage) {
        if (Object.prototype.hasOwnProperty.call(WorkflowStage, key)) {
            if (WorkflowStage[key as keyof typeof WorkflowStage] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkflowStageFromJSON(json: any): WorkflowStage {
    return WorkflowStageFromJSONTyped(json, false);
}

export function WorkflowStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowStage {
    return json as WorkflowStage;
}

export function WorkflowStageToJSON(value?: WorkflowStage | null): any {
    return value as any;
}

export function WorkflowStageToJSONTyped(value: any, ignoreDiscriminator: boolean): WorkflowStage {
    return value as WorkflowStage;
}
